/**
 * The External Services tab: the systems the project's app talks to. Mail is the first and, for now, the only one:
 * the emails the services sent and the Outbox (OutboxPanel), unchanged. CRMs, messaging systems and external APIs are
 * listed next to it, switched off with the "Coming soon" badge the Open App menu's IDE entries use (OpenInMenu).
 * The tab keeps the id `mail` (projectTabsModel, `?tab=mail`), so pins and links made before the rename still open it.
 */
import React from 'react';
import PropTypes from 'prop-types';
import OutboxPanel from './OutboxPanel';
import '../OpenInMenu.css';
import './AppConfig.css';

export const EXTERNAL_SERVICES = [
  { id: 'mail', label: 'Mail', soon: false },
  { id: 'crm', label: 'CRMs', soon: true },
  { id: 'messaging', label: 'Messaging Systems', soon: true },
  { id: 'apis', label: 'APIs & more', soon: true },
];

export default function ExternalServicesPanel({ projectId }) {
  return (
    <div className="ext-services" data-testid="external-services-panel">
      <div aria-label="External services" className="ext-services-nav" role="tablist">
        {EXTERNAL_SERVICES.map((svc) => (svc.soon ? (
          <button aria-disabled="true" aria-selected="false" className="ext-services-item is-soon" data-testid={`external-service-${svc.id}`} disabled key={svc.id} role="tab" type="button">
            <span>{svc.label}</span>
            <span className="open-in-menu-soon">Coming soon</span>
          </button>
        ) : (
          <button aria-selected="true" className="ext-services-item is-on" data-testid={`external-service-${svc.id}`} key={svc.id} role="tab" type="button">
            <span>{svc.label}</span>
          </button>
        )))}
      </div>
      <OutboxPanel projectId={projectId} />
    </div>
  );
}

ExternalServicesPanel.propTypes = { projectId: PropTypes.string.isRequired };
